import { combineReducers } from "redux";
import authReducer from "./authReducer";
import errorReducer from "./errorReducer";
import layoutReducer from "./layoutReducer";
import testLibraryReducer from "./testLibraryReducer";
import candidateTestReducer from "./candidateTestReducer";
import myAssessmentReducer from "./myAssessmentReducer";
import reportReducer from "./reportReducer";
import settingReducer from "./settingReducer";
import usersReducer from "./userReducer";
import gappeoTestReducer from "./gappeoTestReducer";
import myTestsReducer from "./myTestsReducer";
import jobReducer from "./jobsReducer";
import candidateReducer from "./candidateReducer";
import videoInterviewReducer from "./videoInterviewReducer";
import dynamicVoiceCallReducer from "./dynamicVoiceCallReducer";
import dashboardReducer from "./dashboardReducer";
import interviewResultsReducer from "./interviewResultsReducer";
import qualifyQuestionsReducer from "./qualifyQuestionsReducer";
import automationReducer from "./automationReducer";
import { codingNavReducer } from "./codingNavReducer";
import onboardingReducer from "./onboardingReducer";
import chatReducer from "./chatReducer";


export const rootReducer = combineReducers({
  layout: layoutReducer,
  auth: authReducer,
  testLibrary: testLibraryReducer,
  candidateTest: candidateTestReducer,
  myAssessment: myAssessmentReducer,
  myTests: myTestsReducer,
  report: reportReducer,
  setting: settingReducer,
  users: usersReducer,
  gappeoTest: gappeoTestReducer,
  error: errorReducer,
  jobs: jobReducer,
  candidates: candidateReducer,
  videoInterview: videoInterviewReducer,
  dynamicVoiceCall: dynamicVoiceCallReducer,
  dashboard: dashboardReducer,
  interviewResults: interviewResultsReducer,
  qualifyQuestions: qualifyQuestionsReducer,
  automation: automationReducer,
  codingNav: codingNavReducer,
  onboarding: onboardingReducer,
  chat: chatReducer,
});